/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceGroupDetailsForAws extends models.ResourceGroupDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ResourceGroupDetailsForAws");
    }

    getFixupPrototypeFunction() { return ResourceGroupDetailsForAws.fixupPrototype; }

    static newInstance(model: Partial<ResourceGroupDetailsForAws>): ResourceGroupDetailsForAws {
        let obj = Object.assign(new ResourceGroupDetailsForAws(), model);
        ResourceGroupDetailsForAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceGroupDetailsForAws>): ResourceGroupDetailsForAws {
        if (!model) return null;
        return ResourceGroupDetailsForAws.newInstance(<ResourceGroupDetailsForAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceGroupDetailsForAws) {
        if (!obj) return;

        models.ResourceGroupDetailsForAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceGroupDetailsForAws): boolean {
        if (models.ResourceGroupDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceGroupDetailsForAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
